import Partners from "./Partners.component.jsx";

export default Partners;
